module.exports = __webpack_public_path__ + "img/p112.a78949fc.jpg";